import { render, staticRenderFns } from "./ItemCollection.vue?vue&type=template&id=0ecb45c7&scoped=true&"
import script from "./ItemCollection.vue?vue&type=script&lang=js&"
export * from "./ItemCollection.vue?vue&type=script&lang=js&"
import style0 from "./ItemCollection.vue?vue&type=style&index=0&id=0ecb45c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb45c7",
  null
  
)

export default component.exports